export class PriceStoreItemDoesNotExist extends Error {
  constructor(slug: string, message = `Item ${slug} not found in price api`) {
    super(message)
  }
}
